import { SidebarRef } from "../components/sidebar/Sidebar"
import { createRef } from "react"

export const sidebar = createRef<SidebarRef>()
